import styled from 'styled-components';
import { Waypoint } from 'react-waypoint';
import type { NoOpFn } from '~/utilities/util';
import type { JSX } from 'react';
import { CommentAndReplies } from './CommentsAndReplies';
import { CreateCommentForm } from './Forms/CreateCommentForm';
import type { TopLevelComment, ContactData } from './types';
import { EmptyState } from './EmptyState';

// Don't you dare remove the position: relative from this component. Don't ask
// me why, but without it, scrolling to a comment via Element.scrollIntoView()
// will scroll the whole TabbedArea too, which should not be scrollable.
const CommentFormWrapper = styled.div<{ $isRightOfPlayer: boolean }>`
  display: ${({ $isRightOfPlayer }) => ($isRightOfPlayer ? 'flex' : '')};
  flex-direction: ${({ $isRightOfPlayer }) => ($isRightOfPlayer ? 'column-reverse' : '')};
  max-width: 70ch;
  overflow-y: ${({ $isRightOfPlayer }) => ($isRightOfPlayer ? 'auto' : '')};
  position: relative;
`;

const CommentWrapper = styled.div<{ isRightOfPlayer: boolean }>`
  height: 100%;
  overflow-y: ${({ isRightOfPlayer }) => (isRightOfPlayer ? 'auto' : '')};
`;

export const CommentsAndForm = ({
  comments,
  contact,
  mediaId,
  parentId,
  isRightOfPlayer,
  loadMoreFunction,
  hasNextPage,
}: {
  contact: ContactData | null | undefined;
  comments: TopLevelComment[];
  mediaId: string;
  parentId: string | null;
  isRightOfPlayer: boolean;
  loadMoreFunction: NoOpFn;
  hasNextPage: boolean;
}): JSX.Element => {
  return (
    <CommentFormWrapper $isRightOfPlayer={isRightOfPlayer}>
      <CreateCommentForm
        contact={contact}
        isReply={false}
        isRightOfPlayer={isRightOfPlayer}
        parentId={parentId}
        mediaId={mediaId}
      />
      <CommentWrapper isRightOfPlayer={isRightOfPlayer}>
        {comments.length === 0 && <EmptyState />}
        {comments.map((comment) => {
          return (
            <CommentAndReplies
              key={comment.id}
              topLevelComment={comment}
              contact={contact}
              mediaId={mediaId}
              isRightOfPlayer={isRightOfPlayer}
            />
          );
        })}
        {hasNextPage ? (
          <Waypoint
            bottomOffset="-50px"
            onEnter={loadMoreFunction}
          />
        ) : null}
      </CommentWrapper>
    </CommentFormWrapper>
  );
};
